import { RootState } from '../root.reducer'

const getApplicationView = ({ applicationView }) => applicationView

export const getApplicationViewLoading = (state: RootState) => getApplicationView(state).base.status === 'loading'
export const getApplicationViewLoaded = (state: RootState) => getApplicationView(state).base.status === 'loaded'
export const getApplicationViewData = (state: RootState) => getApplicationView(state).base.data

export const getApplicationCustFieldsLoading = (state: RootState) =>
  getApplicationView(state).custFields.status === 'loading'
export const getApplicationCustFieldsLoaded = (state: RootState) =>
  getApplicationView(state).custFields.status === 'loaded'
export const getApplicationCustFieldsData = (state: RootState) => getApplicationView(state).custFields.data
